import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "../features/home/homeSlice";
import newSlice from "../features/news/newSlice";
import seriesSlice from "../features/series/seriesSlice";
import matchInfoSlice from "../features/matchInfo/matchInfoSlice";
import scoreCardSlice from "../features/scoreCard/scoreCardSlice";
import squadSlice from "../features/squad/squadSlice";
import ballByBallSlice from "../features/ballByBall/ballByBallSlice";
import commentarySlice from "../features/commentary/commentarySlice";
import upcomingMatchSlice from "../features/upcomingMatch/upcomingMatchSlice";
import recentMatchSlice from "../features/recentMatch/recentMatchSlice";
import liveScoreSlice from "../features/liveScore/liveScoreSlice";
import newsDetailsSlice from "../features/newsDetails/newsDetailsSlice";
import seriesDetailsSlice from "../features/seriesDetails/seriesDetailsSlice";
import pointsTableSlice from "../features/pointsTable/pointsTableSlice";
import availibilityCheckSlice from "../features/availibilityCheck/availibilityCheckSlice";
import createCampaignSlice from "../features/createCampaign/createCampaignSlice";
import allCampaignSlice from "../features/allCampaign/allCampaignSlice";
import getCampaignByIdSlice from "../features/getCampaignById/getCampaignByIdSlice";
import editCampaignSlice from "../features/editCampaign/editCampaignSlice";
import campaignDetailSlice from "../features/campaignDetail/campaignDetailSlice";
import toggleCampaignSlice from "../features/toggleCampaign/toggleCampaignSlice";
import seriesWithPrioritySlice from "../features/seriesWithPriority/seriesWithPrioritySlice";
import addProductsSlice from "../features/addProducts/addProductsSlice";
import matchesBySeriesIdSlice from "../features/matchesBySeriesId/matchesBySeriesIdSlice";
import matchesRecentBySeriesIdSlice from "../features/matchesRecentBySeriesId/matchesRecentBySeriesIdSlice";
import adminLoginSlice from "../features/adminLogin/adminLoginSlice";
import adminLogoutSlice from "../features/adminLogout/adminLogoutSlice";
import AllRewardProductsSlice from "../features/AllRewardProducts/AllRewardProductsSlice";
import editProductSlice from "../features/editProduct/editProductSlice";
import getProductByIdSlice from "../features/getProductById/getProductByIdSlice";
import deleteProductByIdSlice from "../features/deleteProduct/deleteProductByIdSlice";

export default configureStore({
  reducer: {
    home: homeSlice,
    news: newSlice,
    series: seriesSlice,
    matchInfo: matchInfoSlice,
    scoreCard: scoreCardSlice,
    squad: squadSlice,
    ballByBall: ballByBallSlice,
    commentary: commentarySlice,
    upcoming: upcomingMatchSlice,
    recent: recentMatchSlice,
    liveScore: liveScoreSlice,
    newsDetails: newsDetailsSlice,
    seriesDetails: seriesDetailsSlice,
    pointsTable: pointsTableSlice,
    availibilityCheck: availibilityCheckSlice,
    createCampaign: createCampaignSlice,
    allCampaign: allCampaignSlice,
    getCampaignById: getCampaignByIdSlice,
    editCampaign: editCampaignSlice,
    campaignDetail: campaignDetailSlice,
    toggleCampaignById: toggleCampaignSlice,
    seriesWithPriority: seriesWithPrioritySlice,
    addProducts: addProductsSlice,
    matchesBySeriesId: matchesBySeriesIdSlice,
    matchesRecentBySeriesId: matchesRecentBySeriesIdSlice,
    adminLogin: adminLoginSlice,
    adminLogout: adminLogoutSlice,
    allRewardProducts: AllRewardProductsSlice,
    editProducts: editProductSlice,
    getProductById: getProductByIdSlice,
    deleteProductById: deleteProductByIdSlice,
  },
});
